export default __webpack_public_path__ + "17a999cb3f0ef60c37bb788a53703f38.png";